import type { MenuItem } from '~/types'

type MenuItemsResponse = {
  menuItems: MenuItem[]
}

function sortAndFilterMenuItems(items: MenuItem[] = []): MenuItem[] {
  return items
    .filter((item) => item.is_published)
    .sort((a, b) => a.sort_order - b.sort_order)
    .map((item) => ({
      ...item,
      children: sortAndFilterMenuItems(item.children ?? []),
    }))
}

export async function useMenuItems() {
  const { locale } = useI18n()

  const { data, pending, error, refresh } =
    await usePersistedFetch<MenuItemsResponse>(
      'MenuItems',
      {},
      {
        key: `pqfetch:MenuItems:${locale.value}`,
        headers: () => ({
          'Content-Language': locale.value,
        }),
        watch: [locale],
      },
    )

  const menuItems = computed(() =>
    sortAndFilterMenuItems(data.value?.menuItems ?? []),
  )

  return { menuItems, pending, error, refresh }
}
